import angular from 'angular';
import { CandidateProfileCallForActionLabelConfiguration } from './component';

const MODULE_NAME = 'TALENYA-FE';

angular
    .module(MODULE_NAME)
    .component('candidateProfileCallForActionLabel', CandidateProfileCallForActionLabelConfiguration);

export default MODULE_NAME;